import React from 'react'
import { faLinkedin, faWhatsapp, faGithub, faFacebook } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope } from '@fortawesome/free-regular-svg-icons'

const Footer = () => {
    return (
        <section id="Footer">
            <div className="FooterContainer">
                <div className="FooterContents">
                    Ignatius Michael Dinata
                </div>
                <div className="FooterContents">
                    <div className="Socials">
                        <a href="https://www.linkedin.com/in/ignatius-michael-dinata/" target="_blank" rel="noopener noreferrer">
                            <FontAwesomeIcon size='2x' icon={faLinkedin} />
                        </a>
                        <a href="https://wa.me/6287881374997" target="_blank" rel="noopener noreferrer">
                            <FontAwesomeIcon size='2x' icon={faWhatsapp} />
                        </a>
                        <a href="https://github.com/IgnatiusMD" target="_blank" rel="noopener noreferrer">
                            <FontAwesomeIcon size='2x' icon={faGithub} />
                        </a>
                        <a href="https://www.facebook.com/michael.dinata" target="_blank" rel="noopener noreferrer">
                            <FontAwesomeIcon size='2x' icon={faFacebook} />
                        </a>
                        <a href="mailto:michaeldinata33@gmail.com" target="_blank" rel="noopener noreferrer">
                            <FontAwesomeIcon size='2x' icon={faEnvelope} />
                        </a>
                    </div>
                    <p>Copyright &copy; Ignatius Michael Dinata, All rights reserved.</p>
                </div>
            </div>
        </section>
    )
}

export default Footer
                